/* Cortazu review total per style (22 Oct 2026). Cortazu file, not part of Hyper. Loaded by layout/theme.liquid.
   Works on every element rendered by snippets/cz-review-total.liquid ([data-cz-rt]): that markup already shows the
   sum of the Stamped review metafields of all colour siblings of the style. This script asks Stamped's public badge
   API once per page (public key, the same call Stamped's own badge script makes) for each style's lead product and
   shows the higher total, so every colour, the quick view, the compare table and the PDP show one and the same number.
   - lead product = first product of the colour group (same for every colour), sent with its id, handle and English title
     (Stamped's product groups match on the English title; on NL/DE the title is read from /products/<handle>.js).
   - results are kept for 30 minutes in sessionStorage, so the next page shows the final number straight away.
   - new elements (quick view, compare columns) are picked up by a light MutationObserver.
   Fires 'cz:review-total' on document with { key, count, avg } (used by the PDP review strip, assets/cz-pdp-v2.js). */
(function () {
  'use strict';
  if (window.czReviewTotal) return;
  var d = document;
  var KEY = 'pubkey-DbpG9X8ybp813YH5NgnWZxtk5uTwz5';
  var TTL = 30 * 60 * 1000;
  var store = {};      // key -> { count, avg } (final)
  var pending = {};    // key -> true while asked
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var primary = !(root && root !== '/');

  function num(x) { var n = parseFloat(x); return isFinite(n) ? n : 0; }
  function cacheGet(k) {
    try {
      var c = JSON.parse(sessionStorage.getItem('czRt:' + k) || 'null');
      if (c && Date.now() - c.t < TTL) return c;
    } catch (e) {}
    return null;
  }
  function cacheSet(k, v) { try { sessionStorage.setItem('czRt:' + k, JSON.stringify({ c: v.c, r: v.r, t: Date.now() })); } catch (e) {} }

  function render(el, count, avg) {
    var lang = (d.documentElement.lang || 'en').slice(0, 2);
    var avg1 = (Math.round(avg * 10) / 10).toFixed(1);
    if (lang !== 'en') avg1 = avg1.replace('.', ',');
    var cap = el.querySelector('.cz-rt__cap');
    var fill = el.querySelector('.cz-rt__fill');
    if (cap) cap.textContent = count === 1 ? (el.getAttribute('data-one') || '1 review') : (el.getAttribute('data-tpl') || '%N% reviews').replace('%N%', String(count));
    if (fill) fill.style.setProperty('--cz-rt-pct', Math.max(0, Math.min(100, avg * 20)).toFixed(1) + '%');
    el.setAttribute('aria-label', (el.getAttribute('data-aria') || '%R% / 5 · %N%').replace('%R%', avg1).replace('%N%', String(count)));
    el.setAttribute('data-final-count', String(count));
    el.setAttribute('data-final-avg', String(avg));
    el.hidden = !(count > 0);
  }

  // final total of a style = the higher of the summed metafields and Stamped's own (group) count for the lead product
  function settle(k, api) {
    var els = d.querySelectorAll('[data-cz-rt][data-key="' + k + '"]');
    var best = null;
    els.forEach(function (el) {
      var c = parseInt(el.getAttribute('data-count'), 10) || 0;
      var a = num(el.getAttribute('data-avg'));
      if (!best || c > best.count) best = { count: c, avg: a };
    });
    if (!best) best = { count: 0, avg: 0 };
    if (api && api.c > best.count && api.r > 0) best = { count: api.c, avg: api.r };
    store[k] = best;
    els.forEach(function (el) {
      if (el.getAttribute('data-cz-rt') === 'off') render(el, parseInt(el.getAttribute('data-count'), 10) || 0, num(el.getAttribute('data-avg')));
      else render(el, best.count, best.avg);
      el.setAttribute('data-cz-rt-done', '');
    });
    d.dispatchEvent(new CustomEvent('cz:review-total', { detail: { key: k, count: best.count, avg: best.avg } }));
  }

  function englishTitle(el) {
    var t = el.getAttribute('data-title') || '';
    if (primary) return Promise.resolve(t);
    var h = el.getAttribute('data-sku');
    if (!h) return Promise.resolve(t);
    var ck = 'czRtT:' + h;
    try { var c = sessionStorage.getItem(ck); if (c) return Promise.resolve(c); } catch (e) {}
    return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'omit', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { var x = (p && p.title) || t; try { sessionStorage.setItem(ck, x); } catch (e) {} return x; })
      .catch(function () { return t; });
  }

  function ask(list) {
    if (!list.length) return;
    var shop = (window.Shopify && Shopify.shop) || location.hostname;
    Promise.all(list.map(function (el) {
      return englishTitle(el).then(function (title) {
        return { productId: el.getAttribute('data-key'), productSku: el.getAttribute('data-sku') || '', productTitle: title };
      });
    })).then(function (ids) {
      return fetch('https://stamped.io/api/widget/badges?isIncludeBreakdown=false&isincludehtml=false', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ productIds: ids, apiKey: KEY, storeUrl: shop })
      });
    }).then(function (r) { return r.ok ? r.json() : []; })
      .then(function (rows) {
        var got = {};
        (Array.isArray(rows) ? rows : []).forEach(function (x) {
          if (x && x.productId != null) got[String(x.productId)] = { c: parseInt(x.count, 10) || 0, r: num(x.rating) };
        });
        list.forEach(function (el) {
          var k = el.getAttribute('data-key');
          delete pending[k];
          if (got[k]) cacheSet(k, got[k]);
          settle(k, got[k] || null);
        });
      })
      .catch(function () {
        list.forEach(function (el) { var k = el.getAttribute('data-key'); delete pending[k]; settle(k, null); });
      });
  }

  function scan() {
    var todo = [];
    d.querySelectorAll('[data-cz-rt]:not([data-cz-rt-done])').forEach(function (el) {
      var k = el.getAttribute('data-key');
      if (!k) { el.setAttribute('data-cz-rt-done', ''); return; }
      if (el.getAttribute('data-cz-rt') === 'off') { settle(k, null); return; }
      if (store[k] && !pending[k]) {
        var c = parseInt(el.getAttribute('data-count'), 10) || 0;
        if (c > store[k].count) store[k] = { count: c, avg: num(el.getAttribute('data-avg')) };
        render(el, store[k].count, store[k].avg);
        el.setAttribute('data-cz-rt-done', '');
        return;
      }
      if (pending[k]) return;
      var cached = cacheGet(k);
      if (cached) { settle(k, { c: cached.c, r: cached.r }); return; }
      pending[k] = true;
      todo.push(el);
    });
    ask(todo);
  }

  window.czReviewTotal = { scan: scan, get: function (k) { return store[k] || null; } };
  var t = null;
  function soon() { if (t) return; t = setTimeout(function () { t = null; if (d.querySelector('[data-cz-rt]:not([data-cz-rt-done])')) scan(); }, 150); }
  function start() {
    scan();
    if ('MutationObserver' in window) new MutationObserver(soon).observe(d.body, { childList: true, subtree: true });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();
